import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { GlobalAnimations } from '@core/animations';
import { IconComponent } from '@atoms/icon/icon.component';

@Component({
  selector: 'app-search-input',
  imports: [NgClass, FormsModule, IconComponent],
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
  animations: [GlobalAnimations.popFromRight],
})
export class SearchInputComponent {
  @Input() value: string = '';
  @Input() placeholder: string = '';
  @Input() reset: boolean = false;
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() onSearch: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('inputEl') inputEl?: ElementRef;

  input(): void {
    this.valueChange.emit(this.value);
  }

  search(): void {
    this.onSearch.emit(this.value);
    if (this.reset) {
      this.value = '';
      this.inputEl?.nativeElement.blur();
    }
  }

  clear(): void {
    this.value = '';
    this.valueChange.emit(this.value);
  }
}
